import React from "react";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import { Tooltip as BootstrapTooltip } from "react-bootstrap";
import PropTypes from "prop-types";

const Tooltip = ({ message, children, placement = "bottom" }) => {
  return (
    <OverlayTrigger
      placement={placement}
      overlay={<BootstrapTooltip>{message}</BootstrapTooltip>}
    >
     {children}
    </OverlayTrigger>
  );
};

Tooltip.propTypes = {
  message: PropTypes.string,
  children: PropTypes.element.isRequired,
  placement: PropTypes.string,
};

export default Tooltip;
